import axios from '../axios'

/*
 * 文件管理
 */
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
    // var link = document.createElement('a');
    // link.href = window.URL.createObjectURL(blob);
    // link.download = fileName;
    // link.click();
    // window.URL.revokeObjectURL(link.href);
  }
}
// 删除 ids:文件表的Ids(多个Id用,分隔)
export const batchDelete = (data) => {
  return axios({
    url: '/mAttachUpdateRecord/delete',
    method: 'post',
    data
  })
}
// 文件列表
export const list = (data) => {
  return axios({
    url: '/mAttachUpdateRecord/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}


// 下载 attachId 附件表的Id
export const download = (data) => {
  return axios({
    url: '/mAttachUpdateRecord/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/attachUpdateRecord.js